export const initialNotes = [
  {
    id: '1',
    title: 'Q3 Growth Strategy',
    content: 'Focus on organic acquisition loops. Key channels: viral sharing, SEO optimization for template galleries.',
    x: 100,
    y: 100,
    tags: ['Strategy', 'Q3'],
    type: 'core',
    folderId: 'f1'
  },
  {
    id: '2',
    title: 'Viral Loop Mechanics',
    content: 'Users invite collaborators -> Collaborators experience "aha" moment -> They create their own workspaces.',
    x: 450,
    y: 50,
    tags: ['Product', 'Growth'],
    type: 'idea',
    folderId: 'f1'
  },
  {
    id: '3',
    title: 'SEO Templates',
    content: 'Create 50+ templates for common use cases (e.g., "Startup Pitch Deck Brainstorm", "Novel Character Arc").',
    x: 420,
    y: 250,
    tags: ['Marketing', 'Content'],
    type: 'task',
    folderId: 'f1'
  },
  {
    id: '4',
    title: 'User Interview: Sarah (Founder)',
    content: '"I need a place where my messy thoughts can slowly become structured plans without feeling constrained early on."',
    x: 150,
    y: 450,
    tags: ['Research', 'Interviews'],
    type: 'insight',
    folderId: 'f2'
  },
  {
    id: '5',
    title: 'Competitor Analysis',
    content: 'Most tools are either too rigid (databases) or too loose (whiteboards). We need the middle ground: structured spatial data.',
    x: 500,
    y: 480,
    tags: ['Research'],
    type: 'insight',
    folderId: 'f2'
  },
  {
    id: '6',
    title: 'Q4 Funding Pitch',
    content: 'Drafting the narrative: The future of thought organization is spatial.',
    x: 850,
    y: 150,
    tags: ['Strategy', 'Pitch'],
    type: 'core',
    folderId: 'f3'
  }
];

export const connections = [
  { source: '1', target: '2' },
  { source: '1', target: '3' },
  { source: '4', target: '5' },
  { source: '2', target: '6' },
  { source: '5', target: '1' }
];

export const folders = [
  { id: 'f1', name: 'Product Growth' },
  { id: 'f2', name: 'User Research' },
  { id: 'f3', name: 'Company Building' }
];

export const tags = [
  { name: 'Strategy', count: 12 },
  { name: 'Growth', count: 8 },
  { name: 'Research', count: 15 },
  { name: 'Pitch', count: 3 },
  { name: 'Content', count: 5 }
];